import { AlertTriangle, Check, Info, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * An inline notice: a short message about the state of things, with an
 * optional title and action. The one banner style for in-page states
 * ("Reading starts Mon, Oct 5", "Square isn't connected", "This campaign
 * is wrapped up"). Toasts are Flash; help-article asides are Callout.
 */
export function Notice({ tone = "info", title, children, action, icon, className }) {
  const styles = {
    info: "border-info/25 bg-info/5 [&_svg.notice-icon]:text-info",
    warning: "border-warning/40 bg-warning/10 [&_svg.notice-icon]:text-warning-foreground",
    success: "border-success/25 bg-success/5 [&_svg.notice-icon]:text-success",
    destructive: "border-destructive/30 bg-destructive/5 [&_svg.notice-icon]:text-destructive",
  }[tone];
  const Icon = icon || { warning: AlertTriangle, success: Check, destructive: XCircle }[tone] || Info;

  return (
    <div role={tone === "destructive" || tone === "warning" ? "alert" : "status"} className={cn("flex flex-col gap-3 rounded-xl border p-4 text-sm text-foreground sm:flex-row sm:items-center", styles, className)}>
      <div className="flex flex-1 gap-3">
        <Icon className="notice-icon mt-0.5 h-4 w-4 shrink-0" />
        <div className="min-w-0 leading-relaxed">
          {title && <p className="font-medium">{title}</p>}
          {children && <div className={cn(title && "text-muted-foreground")}>{children}</div>}
        </div>
      </div>
      {action && <div className="shrink-0 pl-7 sm:pl-0">{action}</div>}
    </div>
  );
}
